import { render, staticRenderFns } from "./BookCategoryEditModal.vue?vue&type=template&id=5d98b52a&"
import script from "./BookCategoryEditModal.vue?vue&type=script&lang=js&"
export * from "./BookCategoryEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports